import {SegmentAnalytics} from "components";
import {PartnerAuthModals} from "components/commons";
import React from "react";
import PropTypes from "prop-types";

import Head from "next/head";
import HeaderV2 from "components/HeaderV2";
import PartnerGlobalStyle from "static/next/css/PartnerGlobalStyle";
import {ToastContainer} from "react-toastify";
import {WealthyEnv} from "helpers";
import dynamic from "next/dynamic";

const NewFooter = dynamic(() => import("components/NewFooter/NewFooter"));

const defaultHeaderProps = {
  isPartnerPage: true,
  backgroundColor: "transparent",
  color: "#000000",
  logo: `${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-new-purple-logo.svg`,
  navBackgroundColor: "transparent"
};

const propTypes = {
  seoData: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    keywords: PropTypes.string,
    canonicalUrl: PropTypes.string.isRequired,
    ogImage: PropTypes.string,
    schema: PropTypes.object
  }),
  children: PropTypes.node.isRequired,
  showHeader: PropTypes.bool,
  showFooter: PropTypes.bool,
  showAnalytics: PropTypes.bool,
  showToast: PropTypes.bool,
  includeRecaptcha: PropTypes.bool,
  headerProps: PropTypes.object,
  extraHead: PropTypes.node,
  mainId: PropTypes.string
};

const PartnerPageShell = ({
  seoData,
  children,
  showHeader = true,
  showFooter = true,
  showAnalytics = true,
  showToast = true,
  includeRecaptcha = true,
  headerProps = {},
  extraHead = null,
  mainId = "main-content"
}) => (
  <>
    <PartnerGlobalStyle />

    {seoData ? (
      <Head>
        <title>{seoData.title}</title>
        <meta content={seoData.title} name="title" />
        <meta content={seoData.description} name="description" />
        <meta content={seoData.keywords} name="keywords" />

        <meta content="website" property="og:type" />
        <meta content={seoData.canonicalUrl} property="og:url" />
        <meta content={seoData.title} property="og:title" />
        <meta content={seoData.description} property="og:description" />
        <meta content={seoData.ogImage} property="og:image" />
        <meta content="Wealthy" property="og:site_name" />

        <meta content="summary_large_image" property="twitter:card" />
        <meta content="@wealthy_in" name="twitter:site" />
        <meta content={seoData.canonicalUrl} property="twitter:url" />
        <meta content={seoData.title} property="twitter:title" />
        <meta content={seoData.description} property="twitter:description" />
        <meta content={seoData.ogImage} property="twitter:image" />

        <link href={seoData.canonicalUrl} rel="canonical" />
        <link href="https://i.wlycdn.com/wealthy-home-page/new-fav-icon.png" rel="icon" />

        {seoData.schema ? (
          <script
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(seoData.schema)
            }}
            type="application/ld+json"
          />
        ) : null}

        <link href="/static/next/css/header-footer.css" rel="stylesheet" />
        {includeRecaptcha ? (
          <script src={`https://www.google.com/recaptcha/api.js?render=${WealthyEnv.RECAPTCHA_SITEKEY}`} />
        ) : null}
        {extraHead ? extraHead : null}
      </Head>
    ) : null}

    {showAnalytics ? <SegmentAnalytics /> : null}
    {showToast ? <ToastContainer /> : null}
    <PartnerAuthModals />

    {showHeader ? (
      <HeaderV2
        {...defaultHeaderProps}
        {...headerProps}
      />
    ) : null}

    <main id={mainId}>
      {children}
    </main>

    {showFooter ? <NewFooter /> : null}
  </>
);

PartnerPageShell.propTypes = propTypes;

export default PartnerPageShell;
